import { render, staticRenderFns } from "./sidebarMenuShrink.vue?vue&type=template&id=949f6a84&"
import script from "./sidebarMenuShrink.vue?vue&type=script&lang=js&"
export * from "./sidebarMenuShrink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports